import React from "react";

function MethodologyText() {
  return (
    <div>
      <p style={{ marginTop: "15px" }}>
        Παρακάτω έχει χρησιμοποιθεί το μοντέλο CCR που αποτελεί το πρώτο μοντέλο
        Περιβάλλουσας αποδοτικότητας (DEA) που αναπτύχθηκε από τους Charnes,
        Cooper and Rhodes (1978). Το μοντέλο αυτό βασίζεται στην αντικειμενική
        αξιολόγηση της συνολικής τεχνικής αποδοτικότητας και εκτιμάει ποσοτικά
        τις αιτίες που ενδεχομένως οδηγούν σε έλλειψη αποδοτικότητας,
        αποφεύγοντας την υπερεκτίμηση της αποδοτικότητας των μικρών μονάδων
        λήψης απόφασης (DMUs) στο στοχευόμενο δείγμα.
      </p>

      <p>
        Το CCR στοχεύει στη μείωση των εισροών και στην αύξηση των εκροών με την
        υπόθεση σταθερής απόδοσης κλίμακας (CRS). Το μοντέλο διαθέτει παραγωγικό
        πλάνο (Xik,Yik) όπου Xik είναι οι εισροές και Yik είναι οι εκροές για
        κάθε k παραγωγική μονάδα λήψης απόφασης.
      </p>

      <p>
        Επιπλέον η χρήση της μεθοδολογίας της DEA περιορίζεται από τον αριθμό
        των μεταβλητών που μπορούν να συμπεριληφθούν ως εισροές και εκροές.
        Συγκεκριμένα η βιβλιογραφία ορίζει:
      </p>

      <div className="ref-labels">
        Σύμφωνα με τους Cooper (2006), Tsalas (2010) και Fare et al. (2004)
        ορίζουν ότι: <br /> DMUs &ge; max&#123; εισροές * εκροές, 3*(εισροές +
        εκροές) &#125;
      </div>

      <div className="ref-labels">
        Σύφμωνα με τους Tai et al. (2010), Zhou et al. (2008) and Azaden et al.
        (2004) ισχύει: DMUs &ge; 2*(εισροές + εκροές)
      </div>

      <div className="horizontal-row"></div>
      <div>
        <cite>
          Βιβλιογραφικές αναφορές: <br />
          Charnes A., Cooper, W.W, Rhodes, E. (1978). Measuring the efficiency
          of decision-making units. European Journal of Operational Reasearch, 2
          (6), 429-444.
        </cite>
      </div>

      <div className="horizontal-row"></div>
    </div>
  );
}

export default MethodologyText;
